import EmbeddedFormModal from "../../../popUpForms/formModals/embeddedFormModal";
import PopUpFormSubscribe from "../../../popUpForms/embeddedFormSubscribe";
import { useState } from "react";

const CardSubscribeForUpdates = ({
  form,
  onSuccess,
  onError,
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  return (
    <div
      className="cwpc home-card-box"
      id="subscribe"
      style={{
        border:
          hoveredTab === "subscribe" ? `1px solid var(--cornflower-blue)` : "",
      }}
      hoveredTab={hoveredTab}
      onMouseEnter={() => onTabHover("subscribe")}
      onMouseLeave={() => onTabLeave()}
    >
      <div className="card-content">
        <div className="card-title">
          <h3 className="text-cornflower-blue">Subscribe for Updates!</h3>
        </div>
        <figcaption>
          Providing your contact information enables us to share best practices,
          communicate updates, and network with our global wildfire prevention
          community.
        </figcaption>
        <br />
        <EmbeddedFormModal>
          <PopUpFormSubscribe />
        </EmbeddedFormModal>
      </div>
    </div>
  );
};

export default CardSubscribeForUpdates;
